import i18next from 'i18next'
import isEmpty from 'lodash/isEmpty'
import {urls} from '@/constants/urls'
import {MenuDataItem} from '@/types'
import {ROUTES} from '@/router/routes'

export enum MenuGroupKey {
    MerchantService = 'merchant_service',
    CustomerGrowth = 'customer_growth',
    SettingsAndSupport = 'setting_support'
}

export const getMenuGroupTitles = (): Record<MenuGroupKey, string> => ({
    [MenuGroupKey.MerchantService]: i18next.t('globals:menu.merchantServices'),
    [MenuGroupKey.CustomerGrowth]: i18next.t('globals:menu.customerGrowth'),
    [MenuGroupKey.SettingsAndSupport]: i18next.t('globals:menu.settingsAndSupport')
})

export const menuGroupByPath: Record<string, MenuGroupKey> = {
    [ROUTES.home]: MenuGroupKey.MerchantService,
    [ROUTES.posPayments]: MenuGroupKey.MerchantService,
    [ROUTES.onlinePayments]: MenuGroupKey.MerchantService,
    [ROUTES.paymentLinks]: MenuGroupKey.MerchantService,
    [ROUTES.virtualTerminal]: MenuGroupKey.MerchantService,
    [ROUTES.chargebacks]: MenuGroupKey.MerchantService,
    [ROUTES.posAmexPayments]: MenuGroupKey.MerchantService,
    [ROUTES.exports]: MenuGroupKey.MerchantService,
    [ROUTES.reports]: MenuGroupKey.MerchantService,
    [ROUTES.digitalReceipts]: MenuGroupKey.CustomerGrowth,
    [ROUTES.referAFriend]: MenuGroupKey.CustomerGrowth,
    [ROUTES.zashEpos]: MenuGroupKey.CustomerGrowth,
    [urls.faq]: MenuGroupKey.SettingsAndSupport,
    [ROUTES.settings.base]: MenuGroupKey.SettingsAndSupport
}

export function computeSelectedKey(currentRoute: string, menuItems: MenuDataItem[]) {
    let selectedKey = ''
    for (const item of menuItems) {
        if (currentRoute.startsWith(item.path)) {
            selectedKey = item.path
        }

        if (currentRoute === ROUTES.profile) {
            selectedKey = ''
        }

        if (!isEmpty(item.children)) {
            selectedKey = computeSelectedKey(currentRoute, item.children) || selectedKey
        }
    }
    return selectedKey
}

export function computeOpenKeys(currentRoute: string, menuItems: MenuDataItem[]) {
    const openKeys = []
    for (const item of menuItems) {
        if (isRoutesRelated(currentRoute, item.path) && !isEmpty(item.children)) {
            openKeys.push(item.path)
        }

        if (!isEmpty(item.children)) {
            openKeys.push(...computeOpenKeys(currentRoute, item.children))
        }
    }
    return openKeys
}

function isRoutesRelated(currentRoute: string, route: string) {
    const currentRouteParent = currentRoute && currentRoute.split('/')[1]
    const routeParent = route && route.split('/')[1]

    return Boolean(currentRoute) && Boolean(routeParent) && currentRouteParent === routeParent
}
